import './style.scss';

// The current footer is static. Keep only its back-to-top interaction.
export function footer_block(root = document) {
  const footer = root.querySelector('[data-site-footer]');
  if (!footer || footer.dataset.fbsThemeFooterReady === 'true') return;
  footer.dataset.fbsThemeFooterReady = 'true';

  const backTopButton = footer.querySelector('.fbs-theme-footer-back-top');
  backTopButton?.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  });
}
